import React from 'react';
export const useEscPressedV2 = ({ ref, onEscPress, disablePreventDefault = false, disableStopPropagation = false, }) => {
    React.useEffect(() => {
        const elementToListen = ref?.current || document.body;
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                if (!disablePreventDefault) {
                    event.preventDefault();
                }
                if (!disableStopPropagation) {
                    event.stopPropagation();
                }
                onEscPress(event);
            }
        };
        elementToListen.addEventListener('keydown', handleKeyDown);
        return () => {
            elementToListen.removeEventListener('keydown', handleKeyDown);
        };
    }, [onEscPress]);
};
//# sourceMappingURL=useEscPressedV2.js.map